import S from 'sanctuary'

export default ({ db, bookRepository }) => {
  const ref = ({ userId, bookId }) => db.ref(`/reviews/${userId}/${bookId}`)
  const reviewUrlRef = ({ userId, bookId }) =>
    bookRepository.ref({ userId, bookId }).child('reviewUrl')

  const AUTOSAVE_KEY = 'autosave-review'

  return {
    ref,
    get: async ({ userId, bookId }) => {
      const snaps = await Promise.all([
        reviewUrlRef({ userId, bookId }).once('value'),
        ref({ userId, bookId }).once('value')
      ])

      return new Promise((resolve) => {
        const reviewUrl = snaps[0].val()
        const review = snaps[1].val()

        resolve(
          review
            ? { '.key': snaps[1].key, ...review }
            : reviewUrl
              ? { type: 'url', body: reviewUrl }
              : null
        )
      })
    },
    update: async ({ userId, bookId }, value) => {
      return ref({ userId, bookId }).update(value)
    },
    delete: ({ userId, bookId }) => {
      return Promise.all([
        reviewUrlRef({ userId, bookId }).remove(),
        ref({ userId, bookId }).remove()
      ])
    },
    saveTemp: (bookId, value) => {
      let before = {}

      try {
        before = JSON.parse(localStorage.getItem(AUTOSAVE_KEY)) || {}
      } catch (err) {}

      const after = JSON.stringify(S.insert(bookId)(value)(before))
      localStorage.setItem(AUTOSAVE_KEY, after)
    },
    loadTemp: (bookId) => {
      const item = localStorage.getItem(AUTOSAVE_KEY)
      return item ? JSON.parse(item)[bookId] : ''
    },
    deleteTemp: (bookId) => {
      let before = {}

      try {
        before = JSON.parse(localStorage.getItem(AUTOSAVE_KEY)) || {}
      } catch (err) {}

      const after = JSON.stringify(S.remove(bookId)(before))
      localStorage.setItem(AUTOSAVE_KEY, after)
    }
  }
}
